import { createContext } from 'libs/createContext'

export const defaultDrillDownFilter = {
  isDrillDownOpen: false,
  drillDownFilter: {
    dateRange: [null, null],
    sentiment: null,
    choiceId: null,
    questionId: null,
    customerEmail: null,
    companyName: null,
    teamMemberFilter: null,
    apiName: 'drilldown',
    isTimeSerieChart: false,
  },
}

const initialState: State = {
  surveyId: null,
  surveyToken: null,
  surveyQuestions: [],
  surveyType: null,
  surveyViewToken: null,
  viewName: null,
  defaultViewToken: null,
  isDefaultView: false,
  selectedQuestion: null,
  emailEvents: [],
  isDrillDownOpen: false,
  drillDownFilter: {
    dateRange: [null, null],
    sentiment: null,
    choiceId: null,
    questionId: null,
    customerEmail: null,
    companyName: null,
    teamMemberFilter: null,
    apiName: 'drilldown',
    isTimeSerieChart: false,
  },
  pdfState: {
    surveyName: '',
    leaderboards: {
      company: { results: [], count: 0 },
      customer: { results: [], count: 0 },
      team_member: { results: [], count: 0 },
    },
    statRow: {
      satisfactionLabel: 'Satisfaction',
      positiveLabel: 'Positive',
      neutralLabel: 'Neutral',
      negativeLabel: 'Negative',
      satisfaction: '0',
      satisfactionDiff: 0,
      positive: 0,
      positiveDiff: 0,
      neutral: 0,
      neutralDiff: 0,
      negative: 0,
      negativeDiff: 0,
    },
    metric: '',
  },
  customDashboardState: {
    dashboardToken: null,
    dashboardName: '',
    dashboardWidgets: [],
    dashboardId: null,
    hideFeedbackSideBar: false,
  },
  featureToggleState: { multipleWidgetDatasets: false },
  isShowFilterGroup: false,
  isSurveyTokenContextAndViewNotMatch: false,
  initialViewFilter: {
    dateRangeFilterQuery: ['', ''],
    advancedFilterQuery: { condition: 'and', rules: [] },
  },
  widgetSurvey: null,
  widgetSurveyLoading: true,
  isShowSaveFilterButton: false,
  isShowBenchmark: true,
}

const { context: surveyDashboardContext, Provider: SurveyDashboardProvider } =
  createContext(initialState)

export { surveyDashboardContext, SurveyDashboardProvider }

interface DrillDownFilter {
  dateRange: [string | null, string | null]
  sentiment: string | null
  choiceId: string | null
  questionId: string | null
  customerEmail: string | null
  companyName: string | null
  teamMemberFilter: string | null
  apiName: 'drilldown' | 'drilldown-engagement'
  isTimeSerieChart: boolean
}

interface Question {
  id: number
  type: string
  text: string
  metric: string
  is_opinion_scale: boolean
  order: number
}

interface State {
  surveyId: null | null
  surveyToken: string | null
  surveyQuestions: Question[]
  surveyType: string | null
  surveyViewToken: string | null
  defaultViewToken: string | null
  viewName: string | null
  isDefaultView: false
  selectedQuestion: Question | null
  isDrillDownOpen: boolean
  drillDownFilter: DrillDownFilter
  emailEvents: string[]
  pdfState: PDFState
  customDashboardState: CustomDashboardState
  featureToggleState: FeatureToggleState
  isShowFilterGroup: boolean
  isSurveyTokenContextAndViewNotMatch: boolean
  initialViewFilter: initialViewFilter
  widgetSurvey: SurveyList | null
  widgetSurveyLoading: boolean
  isShowSaveFilterButton: boolean
  isShowBenchmark: boolean
}

interface Leaderboard {
  results: object[]
  count: number
}

interface PDFState {
  surveyName: string
  metric: string
  leaderboards: {
    company: Leaderboard
    customer: Leaderboard
    team_member: Leaderboard
  }
  statRow: {
    satisfactionLabel: 'Satisfaction' | 'Mean score' | 'Net Promoter Score'
    positiveLabel: 'Positive' | 'Promoters'
    neutralLabel: 'Neutral' | 'Passives'
    negativeLabel: 'Negative' | 'Detractors'
    satisfaction: string
    satisfactionDiff: number
    positive: number
    positiveDiff: number
    neutral: number
    neutralDiff: number
    negative: number
    negativeDiff: number
  }
}

interface CustomDashboardState {
  dashboardToken: string | null
  dashboardName: string | null
  dashboardId: string | null
  dashboardWidgets: object[]
  hideFeedbackSideBar: boolean | null
}

interface advancedFilterRules {
  condition: string
  rules: object[]
}

interface advancedFilterGroups {
  globalOperator: string
  groups: object[]
}

type advancedFilterQuery = advancedFilterRules | advancedFilterGroups

interface initialViewFilter {
  dateRangeFilterQuery: [string | null, string | null]
  advancedFilterQuery: advancedFilterQuery
}

interface FeatureToggleState {
  multipleWidgetDatasets: boolean
}
interface SurveyList {
  survey: [WidgetSurvey]
}
interface WidgetSurvey {
  id: number
  namem: string | null
  question: [WidgetQuestion]
  token: string | null
}

interface WidgetQuestion {
  id: number
  type: number
  text: string
  metric?: string
  is_primary_metric?: boolean
}



// WEBPACK FOOTER //
// ./src/pages/Dashboards/SurveyDashboard/context.tsx